module.exports = __webpack_public_path__ + "img/shopping-cart.56433462.svg";